/// <reference types="vite/client" />
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
// Every editor feature — find/replace, multi-cursor, the suggest widget,
// bracket matching — without any language services attached.
import 'monaco-editor/esm/vs/editor/editor.all.js';
// Only the dialects this console speaks. The default `monaco-editor` entry
// point pulls in all ~90 languages it ships with, which meant shipping
// Solidity and FreeMarker tokenizers to analysts writing SQL.
import 'monaco-editor/esm/vs/basic-languages/sql/sql.contribution.js';
import 'monaco-editor/esm/vs/basic-languages/mysql/mysql.contribution.js';
import 'monaco-editor/esm/vs/basic-languages/pgsql/pgsql.contribution.js';
import { loader } from '@monaco-editor/react';
import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';

/**
 * Serve Monaco from our own bundle instead of a public CDN.
 *
 * `@monaco-editor/react` defaults to fetching the editor from jsDelivr at
 * runtime. That is wrong here on two counts:
 *
 *  1. **Supply chain.** It would mean a third party serving executable code
 *     into the one page in the company that renders restricted query results.
 *     A compromised or hijacked CDN response could read every row on screen.
 *  2. **It would not work.** Internal tools frequently run on networks with no
 *     general egress. The editor would simply never load, and the failure
 *     mode is a blank panel with nothing in the console to explain it.
 *
 * Importing the package and handing it to the loader makes Monaco part of our
 * own build, subject to the same CSP and the same review as everything else.
 */
self.MonacoEnvironment = {
  getWorker() {
    // One worker, for the base editor. There are no language services to
    // route to — SQL tokenization is synchronous, and the schema-aware
    // completions are ours, served from the catalog rather than computed here.
    return new editorWorker();
  },
};

loader.config({ monaco });
